import * as React from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core'
import { t } from 'ttag'
import {
  convertCmToFtIn,
  convertFtInToCm,
  DATE_FORMAT,
  isDateOfBirthErrorVisible,
  isDateOfBirthValid,
  isNumberFieldErrorVisible,
  isPasswordFieldErrorVisible,
  isSelectFieldErrorVisible,
  isTextFieldErrorVisible,
  precisionRoundMod,
} from '../../common/helpers/formHelpers'
import { getFormattedUrl } from '../../common/helpers/integrationUrl'
import { openActivityIndexArticle, redirectUrl } from '../../common/helpers/routeHelpers'
import { ROUTES } from '../../common/Routes/routePaths'
import { ButtonGroup } from '../../components/ButtonGroup/ButtonGroup'
import { Card } from '../../components/Card/Card'
import Loader from '../../components/Loader/Loader'
import { TNotificationType } from '../../components/Notification/Notification'
import Notifications from '../../components/Notification/Notifications'
import {
  CompanyCountriesDto,
  CompanyId,
  DivisionDto,
  DivisionId,
  Gender,
  Lang,
  OnboardingStatus,
  RegisterUser$Request,
  ServiceProvider,
  SetUserThirdPartyIntegration$Request,
  Units,
  UserCompanyDto,
  UserProfileDto,
} from '../../services/api.types'
import AppleHealthIcon from './images/apple-health.svg'
import DownloadOnAppstore from './images/download_on_appstore.png'
import FitbitIcon from './images/fitbit.svg'
import GarminIcon from './images/garmin.svg'
import GoogleFitIcon from './images/google-fit.svg'
import PolarIcon from './images/polar.svg'
import SuuntoIcon from './images/suunto.svg'
import './RegisterUser.scss'
import moment from 'moment'
import YumButton from '../../components/YumButton/YumButton'
import Typography from '@material-ui/core/Typography'
import { ReactComponent as CheckedCircleIcon } from '../../assets/v2/icons/checked-circle-blue.svg'
import { ReactComponent as EmptyCircleIcon } from '../../assets/v2/icons/empty-circle-blue.svg'
import ListItemText from '@material-ui/core/ListItemText'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import FormControl from '@material-ui/core/FormControl'
import YumCountrySelect from '../../components/YumCountrySelect/YumCountrySelect'
import YumTimeZoneSelect from '../../components/YumTimeZoneSelect/YumTimeZoneSelect'
import FormLabel from '@material-ui/core/FormLabel'
import convert from 'convert-units'
import { Capacitor } from '@capacitor/core'
import { isNative } from '../../common/helpers/isNative'
import { store } from '../../index'
import { getUserCompanies } from './store/RegisterUserSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import { yuMuuvPublicCompanyId } from '../Settings/Settings'
import {
  unitsCountLengthCentimeterShort,
  unitsCountLengthFootShort,
  unitsCountLengthInchShort,
  unitsCountMassKilogramShort,
  unitsCountMassPoundShort,
} from '../../common/helpers/units'
import YumSelect from '../../components/YumSelect/YumSelect'
import { ReactComponent as DateActiveIcon } from '../../assets/v3/icons/date-active.svg'
import { ReactComponent as DateInactiveIcon } from '../../assets/v3/icons/date-inactive.svg'
import { ReactComponent as WeightActiveIcon } from '../../assets/v3/icons/weight-active.svg'
import { ReactComponent as WeightInactiveIcon } from '../../assets/v3/icons/weight-inactive.svg'
import { ReactComponent as HeightActiveIcon } from '../../assets/v3/icons/height-active.svg'
import { ReactComponent as HeightInactiveIcon } from '../../assets/v3/icons/height-inactive.svg'
import YumInput from '../../components/YumInput/YumInput'

import { ReactComponent as CheckboxIcon } from '../../assets/v3/icons/checkbox.svg'
import { ReactComponent as CheckboxSelectedIcon } from '../../assets/v3/icons/checkbox-selected.svg'
import { ReactComponent as GoogleIcon } from '../../assets/v2/icons/icon-google.svg'

import { ReactComponent as SmallCheckIcon } from '../../assets/v3/icons/small-check.svg'
import { ReactComponent as AppleSmallIcon } from '../../assets/v3/icons/integrations/apple.svg'
import { ReactComponent as FitbitSmallIcon } from '../../assets/v3/icons/integrations/fitbit.svg'
import { ReactComponent as GarminSmallIcon } from '../../assets/v3/icons/integrations/garmin.svg'
import { ReactComponent as PolarSmallIcon } from '../../assets/v3/icons/integrations/polar.svg'
import { ReactComponent as GoogleSmallIcon } from '../../assets/v3/icons/integrations/google.svg'
//import { ReactComponent as SuuntoSmallIcon } from '../../assets/v3/icons/integrations/suunto.svg'
import SuuntoSmallIcon from '../../assets/v3/icons/integrations/suunto.png'
import { currentLang } from '../../i18nInit'
import { Preferences } from '@capacitor/preferences'
import YumTeamSelect from '../../components/YumTeamSelect/YumTeamSelect'

export interface IStateProps {
  userDto: UserProfileDto
  userCompanies: UserCompanyDto[]
  countries: CompanyCountriesDto[]
  divisions: DivisionDto[]
  userIntegrationScopes: string
}

export interface IDispatchProps {
  registerUser(payload: any): void
  registerAppleHealth(payload?: RegisterUser$Request): void
  registerWithoutIntegration(): void
  getWhoAmI(): void
  setIntegration(payload: SetUserThirdPartyIntegration$Request): void
  appleHealthIntegration(): void
  initialAppleHealthIntegration(payload: any): void
  reLocate(): void
  getUserCompanyCountries(): void
  getCompanyDivisions(): void
  updateProfileData(payload: any): void
  updateActivityData(payload: any): void
}

type IRegisterUserProps = IStateProps & IDispatchProps

export interface IRegisterUserState {
  password: string
  appleHealthPasswordError: boolean
  integration: string | null
  appleHealthNonIosProcess: boolean
  appleHealthNonIosProcessSuccess: boolean
  firstName: string
  lastName: string
  dateOfBirth: string
  dateOfBirthError: boolean
  gender: Gender.MALE | Gender.FEMALE
  units: Units.METRIC | Units.IMPERIAL
  weight: string | number
  weightLbs: string | number
  height: string | number
  heightFt: string | number
  heightIn: string | number
  isProfileFormValid: boolean
  isActivityDataFormValid: boolean
  country: string
  timeZone: string
  divisionId: DivisionId
  newsletterSubscriber: boolean
  hasSingleCompany: boolean
  isActivityIndexFieldRequired: boolean
  companyId: CompanyId
}

export const MIN_HEIGHT_CM = 100
export const MIN_WEIGHT_KG = 25

const companyIdBetssonGroup = '6eb3c619-59cb-40c0-b87f-204877bfb5b5'
//const companyIdYuMuuvTeam = '2d098838-2d06-ea86-3445-b9d039fbd0d3'
/*export const isCompanyDivisionRequired = (companyId: CompanyId) => {
  return companyId === companyIdBetssonGroup //|| companyId === companyIdYuMuuvTeam
}*/
/*export const isCompanyCountryRequired = (companyId: CompanyId) => {
  return companyId === companyIdBetssonGroup //|| companyId === companyIdYuMuuvTeam
}*/
export const isBurgerHidden = (companyId: CompanyId) => {
  return companyId === companyIdBetssonGroup //|| companyId === companyIdYuMuuvTeam
}

export const isCompanyDivisionRequired = (companyId: CompanyId) => {
  const userCompanies = getUserCompanies(store.getState() as any as IGlobalState)
  const userCompany = userCompanies.find((uc) => uc.companyId === companyId)
  return !!userCompany?.divisionRequired
}

export const isCompanyCountryRequired = (companyId: CompanyId) => {
  const userCompanies = getUserCompanies(store.getState() as any as IGlobalState)
  const userCompany = userCompanies.find((uc) => uc.companyId === companyId)
  return !!userCompany?.countryRequired
}

const timeZoneGuess = moment.tz.guess(true)
const isUsa = timeZoneGuess.startsWith('America/')

export class RegisterUser extends React.Component<IRegisterUserProps, IRegisterUserState> {
  constructor(props: IRegisterUserProps) {
    super(props)

    const defaultProfile = {
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      dateOfBirthError: false,
      gender: Gender.MALE,
      units: isUsa ? Units.IMPERIAL : Units.METRIC,
      weight: '',
      height: '',
      country: '',
      timeZone: timeZoneGuess,
      divisionId: '',
      weightLbs: '',
      heightFt: '',
      heightIn: '',
      newsletterSubscriber: false,
    }

    this.state = {
      password: '',
      appleHealthPasswordError: false,
      integration: '',
      appleHealthNonIosProcess: false, //window.localStorage.getItem('isAppleHealthIntegration') === '1',
      appleHealthNonIosProcessSuccess: false,
      isProfileFormValid: true,
      isActivityDataFormValid: true,
      hasSingleCompany: true,
      isActivityIndexFieldRequired: true,
      companyId: '',
      ...defaultProfile,
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('register-user-page')
  }

  async componentDidMount(): Promise<void> {
    document.body.classList.add('register-user-page')

    const { setIntegration, reLocate } = this.props
    reLocate()
    const { authorizationCode, serviceProvider } = await getFormattedUrl()
    const redirectUrlString = `${window.location.origin}${ROUTES.INTEGRATION_PROXY.to}`

    if (authorizationCode) {
      setIntegration({ authorizationCode, serviceProvider, redirectUrl: redirectUrlString })
    } else {
      this.props.getUserCompanyCountries()
      this.props.getCompanyDivisions()

      const { value: appleHealthNonIosProcess } = await Preferences.get({ key: 'isAppleHealthIntegration' })
      this.setState({ appleHealthNonIosProcess: appleHealthNonIosProcess === '1' })
    }
  }

  async UNSAFE_componentWillReceiveProps(nextProps: any) {
    const { userDto, userCompanies } = nextProps
    const { serviceProvider } = userDto

    let companyId = userCompanies.find((uc: { companyId: string }) => uc.companyId !== yuMuuvPublicCompanyId)?.companyId
    if (!companyId) companyId = yuMuuvPublicCompanyId
    this.setState({ companyId })

    if (serviceProvider !== '') {
      const {
        firstName,
        lastName,
        dateOfBirth: userDateOfBirth,
        gender: userGender,
        weight,
        height,
        timeZone,
        newsletterSubscriber,
        units,
      } = userDto

      if (!this.state.firstName) this.setState({ firstName })
      if (!this.state.lastName) this.setState({ lastName })

      if (serviceProvider === ServiceProvider.APPLE_HEALTH) {
        if (this.state.integration !== serviceProvider) this.setState({ integration: serviceProvider })
      } else {
        const dateOfBirth = userDateOfBirth ? moment(userDateOfBirth).format(DATE_FORMAT) : ''
        const gender = userGender ? userGender : Gender.MALE

        const { heightFt, heightIn } = convertCmToFtIn(this.state.height as string)
        const weightLbs = precisionRoundMod(convert(weight).from('kg').to('lb'), 5)

        this.setState({
          firstName,
          lastName,
          dateOfBirth,
          gender,
          weight,
          height,
          heightFt,
          heightIn,
          weightLbs,
          integration: serviceProvider,
          newsletterSubscriber,
        })

        if (timeZone) this.setState({ timeZone })
        if (units) this.setState({ units })

        const hasSingleCompany = userCompanies && userCompanies.length === 1
        this.setState({ hasSingleCompany })
        if (hasSingleCompany) {
          if (userCompanies[0]) {
            const { divisionId, country } = userCompanies[0]
            if (divisionId) this.setState({ divisionId })
            if (country) this.setState({ country })
          }
        }
      }
    }
  }

  handleIsActivityIndexFieldRequired = () => {
    const { dateOfBirth, height, weight, weightLbs, units } = this.state
    const isActivityIndexFieldRequired = !!(dateOfBirth || (units === Units.IMPERIAL ? weightLbs : height || weight))
    this.setState({ isActivityIndexFieldRequired })
  }

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target

    if (['weight', 'weightLbs', 'height'].includes(name)) {
      this.setState({ [name]: value } as any, () =>
        this.setState({ isActivityDataFormValid: this.isActivityDataFormValid() }),
      )
    } else {
      this.setState({ [name]: value } as any, () => this.setState({ isProfileFormValid: this.isProfileFormValid() }))
    }

    if ('weight' === name) {
      let weightLbs = convert(parseFloat(value)).from('kg').to('lb')
      weightLbs = precisionRoundMod(weightLbs, 5)
      this.setState({ weightLbs }, () => {
        //this.handleIsActivityIndexFieldRequired()
      })
    }

    if ('weightLbs' === name) {
      let weight = convert(parseFloat(value)).from('lb').to('kg')
      weight = precisionRoundMod(weight, 5)
      this.setState({ weight }, () => {
        //this.handleIsActivityIndexFieldRequired()
      })
    }

    if ('height' === name) {
      const { heightFt, heightIn } = convertCmToFtIn(value)
      this.setState({ heightFt, heightIn }, () => {
        //this.handleIsActivityIndexFieldRequired()
      })
    }
  }

  handleHeightFtChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value: number = parseInt(event.target.value as string)
    const height = convertFtInToCm(value, parseInt(this.state.heightIn as string))
    this.setState({ heightFt: value, height })
  }

  handleHeightInChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value: number = parseInt(event.target.value as string)
    const height = convertFtInToCm(parseInt(this.state.heightFt as string), value)
    this.setState({ heightIn: value, height })
  }

  handleDOBChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ dateOfBirth: event.target.value }, () => {
      this.setState({ isActivityDataFormValid: this.isActivityDataFormValid() })
      //this.handleIsActivityIndexFieldRequired()
    })
  }

  handleCountryChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ country: event.target.value as string })
  }

  handleDivisionChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const { value } = event.target as { value: string }
    this.setState({ divisionId: value || null })
  }

  handleTimeZoneChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ timeZone: event.target.value as string })
  }

  setIntegration = (integration: string | null) => () => this.setState({ integration })

  onClickIntegration = () => {
    const serviceProvider = this.state.integration
    if (serviceProvider === ServiceProvider.APPLE_HEALTH) {
      if (!isNative() || Capacitor.getPlatform() !== 'ios') {
        this.setState({ appleHealthNonIosProcess: true }, async () => {
          await Preferences.set({ key: 'isAppleHealthIntegration', value: '1' })
          this.props.appleHealthIntegration()
        })
      } else {
        const { password } = this.state
        this.props.registerAppleHealth({ password })
        /*if (!password) {
          this.getMetadataFromAppleHealth()
        }*/
      }
    }
    if (serviceProvider === null) {
      this.props.registerWithoutIntegration()
    }
  }

  /*hasDistanceScope = () => {
    const alreadyHasDistance = this.props.userIntegrationScopes?.includes(
      'https://www.googleapis.com/auth/fitness.location.read',
    )
    const distanceIsMandatory =
      this.props.userCompanies && this.props.userCompanies.some((uc) => uc.scope?.toLowerCase().includes('distance'))
    return alreadyHasDistance || distanceIsMandatory
  }*/

  hasSleepScope = () =>
    this.props.userCompanies && this.props.userCompanies.some((uc) => uc.scope?.includes('syncSleep'))

  doIntegration = () => {
    const { integration } = this.state

    if (integration === ServiceProvider.APPLE_HEALTH || integration === null) {
      return ''
    }

    // Distance
    /*let withDistance = ''
    if (integration === ServiceProvider.GOOGLE_FIT && this.hasDistanceScope()) {
      withDistance = '&d=1'
    }*/

    // Sleep
    let withSleep = ''
    if (integration === ServiceProvider.GOOGLE_FIT && this.hasSleepScope()) {
      withSleep = '&s=1'
    }

    const { dateOfBirth } = this.props.userDto
    const scope = !dateOfBirth ? 'LEAN' : 'FULL'
    return integration ? `${ROUTES.INTEGRATION_PROXY.to}?type=${integration}&scope=${scope}${withSleep}` : ''
  }

  isProfileFormValid() {
    const { firstName, lastName, password, divisionId, country, companyId } = this.state

    const companyDivisions =
      this.props.divisions && this.props.divisions.filter((division) => division.companyId === companyId)
    const companyCountries =
      this.props.countries && this.props.countries.find((country) => country.companyId === companyId)
    const isDivisionRequired = companyDivisions && companyDivisions.length && isCompanyDivisionRequired(companyId)
    const isCountryRequired =
      companyCountries && companyCountries.countries.length && isCompanyCountryRequired(companyId)
    const isDivisionInvalid = isDivisionRequired && !divisionId
    const isCountryInvalid = isCountryRequired && !country

    return !(
      !firstName ||
      !lastName ||
      isDivisionInvalid ||
      isCountryInvalid ||
      (password.trim().length < 6 &&
        this.props.userDto.serviceProvider !== ServiceProvider.APPLE_HEALTH &&
        !this.props.userDto.passwordSet &&
        !this.props.userDto.googleId &&
        !this.props.userDto.appleId)
    )
  }

  isActivityDataFormValid() {
    const { dateOfBirth, weight, height, isActivityIndexFieldRequired } = this.state

    let isWeightInvalid
    if (typeof weight === 'string') {
      isWeightInvalid = weight ? parseInt(weight, 10) < MIN_WEIGHT_KG || weight.length === 0 : true
    } else {
      isWeightInvalid = weight ? weight < MIN_WEIGHT_KG : true
    }
    let isHeightInvalid
    if (typeof height === 'string') {
      isHeightInvalid = height ? parseInt(height, 10) < MIN_HEIGHT_CM || height.length === 0 : true
    } else {
      isHeightInvalid = height ? height < MIN_HEIGHT_CM : true
    }

    return !(!isDateOfBirthValid(dateOfBirth) || isWeightInvalid || isHeightInvalid)
  }

  onSubmitProfile = () => {
    const { registerUser } = this.props
    const { firstName, lastName, password, divisionId, country, timeZone, newsletterSubscriber, hasSingleCompany } =
      this.state
    this.setState({ isProfileFormValid: this.isProfileFormValid() }, () => {
      if (this.state.isProfileFormValid) {
        registerUser({
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          password,
          divisionId: divisionId !== '' ? divisionId : null,
          country,
          timeZone,
          newsletterSubscriber,
          onlyProfileUpdate: !hasSingleCompany,
        })
      }
    })
  }

  onSubmitActivityData = () => {
    const { updateActivityData } = this.props
    const { dateOfBirth: userDateOfBirth, gender, weight, height, units } = this.state
    this.setState(
      { isActivityIndexFieldRequired: true, isActivityDataFormValid: this.isActivityDataFormValid() },
      () => {
        if (this.state.isActivityDataFormValid) {
          updateActivityData({
            dateOfBirth: moment(userDateOfBirth, DATE_FORMAT).locale('en').format('YYYY-MM-DD'),
            gender,
            height,
            weight,
            units,
          })
        }
      },
    )
  }

  onSkipActivityData = () => {
    const { updateActivityData } = this.props
    updateActivityData({})
  }

  setGender = (event: any, gender: any) => this.setState({ gender })

  setUnits = (event: any, units: any) => this.setState({ units })

  setNewsletterSubscriber = (event: any, newsletterSubscriber: any) => this.setState({ newsletterSubscriber })

  getProfileForm = () => {
    const {
      firstName,
      lastName,
      dateOfBirth,
      weight,
      weightLbs,
      height,
      heightFt,
      heightIn,
      gender,
      password,
      isProfileFormValid,
      country,
      divisionId,
      timeZone,
      units,
      newsletterSubscriber,
      hasSingleCompany,
      isActivityIndexFieldRequired,
      companyId,
    } = this.state
    const { serviceProvider, passwordSet, googleId, appleId } = this.props.userDto
    const companyDivisions =
      this.props.divisions && this.props.divisions.filter((division) => division.companyId === companyId)
    const companyCountries =
      this.props.countries && this.props.countries.find((country) => country.companyId === companyId)

    const isDivisionRequired = isCompanyDivisionRequired(companyId)
    const isCountryRequired = isCompanyCountryRequired(companyId)

    const useAutocompleteSelect =
      this.props.userCompanies && this.props.userCompanies.some((uc) => uc.scope?.includes('useAutocompleteSelect'))

    return (
      <>
        <Typography variant="subtitle2" style={{ marginBottom: 16 }}>{t`Edit profile`}</Typography>

        <Grid container spacing={3} style={{ marginBottom: 18 }}>
          <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
            <TextField
              variant="filled"
              InputProps={{
                disableUnderline: true,
                autoComplete: 'given-name',
              }}
              value={firstName || ''}
              label={t`First name`}
              fullWidth={true}
              type="text"
              name="firstName"
              required={true}
              error={isTextFieldErrorVisible(firstName, isProfileFormValid)}
              style={{
                marginBottom: 0,
              }}
              onChange={this.handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
            <TextField
              variant="filled"
              InputProps={{
                disableUnderline: true,
                autoComplete: 'family-name',
              }}
              value={lastName || ''}
              label={t`Last name`}
              fullWidth={true}
              type="text"
              name="lastName"
              required={true}
              error={isTextFieldErrorVisible(lastName, isProfileFormValid)}
              style={{
                marginBottom: 0,
              }}
              onChange={this.handleInputChange}
            />
          </Grid>
        </Grid>

        <FormControl style={{ marginBottom: 18, display: 'block' }}>
          <YumTimeZoneSelect
            label={t`Time zone`}
            value={timeZone}
            onChange={this.handleTimeZoneChange}
            required={true}
            useAutocompleteSelect={useAutocompleteSelect}
            style={{
              marginBottom: 0,
            }}
          />
        </FormControl>

        {hasSingleCompany &&
        ((companyCountries && companyCountries.countries.length) || (companyDivisions && companyDivisions.length)) ? (
          <Grid container spacing={3} style={{ marginBottom: 12 }}>
            {companyDivisions && companyDivisions.length ? (
              <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
                <YumTeamSelect
                  label={t`Team`}
                  companyDivisions={companyDivisions}
                  value={divisionId || ''}
                  /*required={isDivisionRequired}*/
                  onChange={this.handleDivisionChange}
                  error={isDivisionRequired && isSelectFieldErrorVisible(divisionId, isProfileFormValid)}
                  showIcon={true}
                  useAutocompleteSelect={useAutocompleteSelect}
                  style={{
                    marginBottom: 0,
                  }}
                />
              </Grid>
            ) : (
              ''
            )}

            {companyCountries && companyCountries.countries.length ? (
              <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
                <YumCountrySelect
                  label={t`Country`}
                  countries={companyCountries.countries}
                  value={country}
                  /*required={isCountryRequired}*/
                  onChange={this.handleCountryChange}
                  error={isCountryRequired && isSelectFieldErrorVisible(country, isProfileFormValid)}
                  showIcon={true}
                  useAutocompleteSelect={useAutocompleteSelect}
                  style={{
                    marginBottom: 0,
                  }}
                />
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        ) : (
          ''
        )}

        {/*{serviceProvider !== null && (*/}
        {/*<Accordion defaultExpanded={false} style={{ margin: '30px 0 20px' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
          >{t`Data for YuMuuv Activity Index (optional)`}</AccordionSummary>
          <AccordionDetails>

          </AccordionDetails>
        </Accordion>*/}
        {/*)}*/}

        <FormGroup row={true}>
          <FormControlLabel
            control={
              <Checkbox
                name="newsletterSubscriber"
                checked={newsletterSubscriber}
                onChange={this.setNewsletterSubscriber}
              />
            }
            label={t`Subscribe to newsletter`}
          />
        </FormGroup>
        {serviceProvider !== ServiceProvider.APPLE_HEALTH && !passwordSet && !googleId && !appleId ? (
          <TextField
            label={t`Add password:`}
            type="password"
            name="password"
            required={true}
            error={isPasswordFieldErrorVisible(password, isProfileFormValid)}
            style={{
              marginBottom: 16,
            }}
            onChange={this.handleInputChange}
          />
        ) : null}
        <ButtonGroup>
          <YumButton onClick={this.onSubmitProfile}>{t`Next`}</YumButton>
        </ButtonGroup>
      </>
    )
  }

  getActivityForm = () => {
    const {
      dateOfBirth,
      weight,
      weightLbs,
      height,
      heightFt,
      heightIn,
      gender,
      isProfileFormValid,
      isActivityDataFormValid,
      units,
      isActivityIndexFieldRequired,
    } = this.state

    const activityIndexNotice =
      currentLang === Lang.EN || currentLang === Lang.ET
        ? t`We need this data for activity index calculation. If you only want to participate in other types of challenges, you can skip this.`
        : t`We need this data for activity index calculation. If you only want to participate in step or manual data entry challenges, you can skip this.`

    return (
      <>
        <Typography variant="subtitle2" style={{ marginBottom: 16 }}>{t`YuMuuv Activity Index`}</Typography>

        {/*<div>{t`We need additional data to calculate <a href="https://yumuuv.com/en/blog/physical-activity-level-calculator">YuMuuv activity index</a>. If you only want to participate in step or manual data entry challenges, you don’t need to add them.`}</div>*/}
        <div className="info">
          <span>{activityIndexNotice}</span>
          {` `}
          <a href={undefined} onClick={openActivityIndexArticle}>{t`Learn more`}</a>
        </div>
        <FormGroup row={true}>
          <FormControl component="fieldset" style={{ margin: '0 10px 12px 10px' }}>
            <FormLabel
              required={isActivityIndexFieldRequired}
              component="legend"
              style={{ fontSize: 12 }}
            >{t`Sex`}</FormLabel>
            <RadioGroup
              row={true}
              name="sex"
              defaultValue={gender ? gender : Gender.MALE}
              value={gender ? gender : Gender.MALE}
              onChange={this.setGender}
            >
              <FormControlLabel
                control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                value={Gender.MALE.toString()}
                label={t`Male`}
              />
              <FormControlLabel
                control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                value={Gender.FEMALE.toString()}
                label={t`Female`}
              />
            </RadioGroup>
          </FormControl>
        </FormGroup>
        {/*<TextField
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          label={t`Date of birth`}
          helperText={t`Format: DD.MM.YYYY`}
          required={isActivityIndexFieldRequired}
          error={isDateOfBirthErrorVisible(dateOfBirth, !isActivityIndexFieldRequired || isActivityDataFormValid)}
          value={dateOfBirth}
          onChange={this.handleDOBChange}
          style={{ marginBottom: 24 }}
        />*/}
        <YumInput
          label={t`Date of birth`}
          helperText={t`Format: DD.MM.YYYY`}
          variant="filled"
          startIcon={DateActiveIcon}
          startIconInactive={DateInactiveIcon}
          value={dateOfBirth}
          onChange={this.handleDOBChange}
          error={isDateOfBirthErrorVisible(dateOfBirth, !isActivityIndexFieldRequired || isActivityDataFormValid)}
          style={{ marginBottom: 24 }}
        />

        <FormGroup row={true} className="">
          <FormControl component="fieldset" style={{ margin: '0 10px 12px 10px' }}>
            <FormLabel
              required={isActivityIndexFieldRequired}
              component="legend"
              style={{ fontSize: 12 }}
            >{t`Units of measure`}</FormLabel>
            <RadioGroup row aria-label="units" name="units" onChange={this.setUnits} value={units || Units.METRIC}>
              <FormControlLabel
                control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                value={Units.METRIC}
                label={t`Metric`}
              />
              <FormControlLabel
                control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                value={Units.IMPERIAL}
                label={t`Imperial`}
              />
            </RadioGroup>
          </FormControl>
        </FormGroup>

        {units === Units.METRIC && (
          <Grid container spacing={3}>
            <Grid item xs={6}>
              {/*<YumField
                label={t`Date of birth`}
                helperText={t`Format: DD.MM.YYYY`}
                variant="filled"
                startIcon={DateActiveIcon}
                startIconInactive={DateInactiveIcon}
                value={dateOfBirth}
                onChange={this.handleDOBChange}
                error={isDateOfBirthErrorVisible(dateOfBirth, !isActivityIndexFieldRequired || isActivityDataFormValid)}
                style={{ marginBottom: 24 }}
              />*/}
              <YumInput
                startIcon={WeightActiveIcon}
                startIconInactive={WeightInactiveIcon}
                variant="filled"
                label={t`Weight`}
                type="text"
                inputProps={{ inputMode: 'numeric', min: MIN_WEIGHT_KG }}
                InputProps={{
                  disableUnderline: true,
                  endAdornment: <InputAdornment position="end">{unitsCountMassKilogramShort}</InputAdornment>,
                }}
                name="weight"
                value={weight || ''}
                required={isActivityIndexFieldRequired}
                error={isNumberFieldErrorVisible(
                  weight as string,
                  !isActivityIndexFieldRequired || isActivityDataFormValid,
                  MIN_WEIGHT_KG,
                )}
                style={{
                  marginBottom: 16,
                }}
                onChange={this.handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <YumInput
                startIcon={HeightActiveIcon}
                startIconInactive={HeightInactiveIcon}
                variant="filled"
                label={t`Height`}
                value={height || ''}
                required={isActivityIndexFieldRequired}
                error={isNumberFieldErrorVisible(
                  height as string,
                  !isActivityIndexFieldRequired || isActivityDataFormValid,
                  MIN_HEIGHT_CM,
                )}
                type="text"
                inputProps={{ inputMode: 'numeric', min: MIN_HEIGHT_CM }}
                InputProps={{
                  disableUnderline: true,
                  endAdornment: <InputAdornment position="end">{unitsCountLengthCentimeterShort}</InputAdornment>,
                }}
                name="height"
                onChange={this.handleInputChange}
                style={{
                  marginBottom: 16,
                }}
              />
            </Grid>
          </Grid>
        )}

        {units === Units.IMPERIAL && (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={5} style={{ paddingBottom: 0 }}>
              <YumInput
                startIcon={WeightActiveIcon}
                startIconInactive={WeightInactiveIcon}
                style={{ width: '100%', marginBottom: 0 }}
                variant="filled"
                label={t`Weight`}
                type="text"
                inputProps={{ inputMode: 'numeric' }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">{unitsCountMassPoundShort}</InputAdornment>,
                }}
                name="weightLbs"
                value={weightLbs || ''}
                required={isActivityIndexFieldRequired}
                error={isNumberFieldErrorVisible(
                  weight as string,
                  !isActivityIndexFieldRequired || isActivityDataFormValid,
                  MIN_WEIGHT_KG,
                )}
                onChange={this.handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={7}>
              <Grid container spacing={1} style={{ marginBottom: 12 }}>
                <Grid item xs={6}>
                  <YumSelect
                    startIcon={HeightActiveIcon}
                    label={t`Height`}
                    value={heightFt}
                    onChange={this.handleHeightFtChange}
                    error={isNumberFieldErrorVisible(
                      height as string,
                      !isActivityIndexFieldRequired || isActivityDataFormValid,
                      MIN_HEIGHT_CM,
                    )}
                  >
                    {[...Array(7)].map((e, i) => {
                      i += 3
                      return (
                        <option key={i} value={i}>
                          {i} {unitsCountLengthFootShort}
                        </option>
                      )
                    })}
                  </YumSelect>
                </Grid>
                <Grid item xs={6}>
                  <YumSelect
                    label={t`Height`}
                    value={heightIn}
                    onChange={this.handleHeightInChange}
                    error={isNumberFieldErrorVisible(
                      height as string,
                      !isActivityIndexFieldRequired || isActivityDataFormValid,
                      MIN_HEIGHT_CM,
                    )}
                  >
                    {[...Array(12)].map((e, i) => {
                      return (
                        <option key={i} value={i}>
                          {i} {unitsCountLengthInchShort}
                        </option>
                      )
                    })}
                  </YumSelect>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}

        <ButtonGroup>
          <YumButton onClick={this.onSubmitActivityData}>{t`Save`}</YumButton>
          <YumButton variant="outlined" onClick={this.onSkipActivityData}>{t`Skip`}</YumButton>
        </ButtonGroup>
      </>
    )
  }

  getIntegrationForm = () => (
    <>
      <Typography variant="subtitle2" style={{ marginBottom: '14px' }}>{t`Choose integration`}</Typography>
      <List>
        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('APPLE_HEALTH')}
          selected={this.state.integration === 'APPLE_HEALTH'}
          style={{ marginBottom: 16 }}
        >
          <ListItemIcon>
            {this.state.integration === 'APPLE_HEALTH' ? <CheckedCircleIcon /> : <EmptyCircleIcon />}
          </ListItemIcon>
          <ListItemText primary={`Apple Health`} />
          <ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="apple-health" src={AppleHealthIcon} alt={`Apple Health`} />
          </ListItemIcon>
        </ListItem>

        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('FITBIT')}
          selected={this.state.integration === 'FITBIT'}
          style={{ marginBottom: 16 }}
        >
          <ListItemIcon>
            {this.state.integration === 'FITBIT' ? <CheckedCircleIcon /> : <EmptyCircleIcon />}
          </ListItemIcon>
          <ListItemText primary={`Fitbit`} />
          <ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="fitbit" src={FitbitIcon} alt={`Fitbit`} />
          </ListItemIcon>
        </ListItem>

        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('GARMIN')}
          selected={this.state.integration === 'GARMIN'}
          style={{ marginBottom: 16 }}
        >
          <ListItemIcon>
            {this.state.integration === 'GARMIN' ? <CheckedCircleIcon /> : <EmptyCircleIcon />}
          </ListItemIcon>
          <ListItemText primary={`Garmin Connect`} />
          <ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="garmin" src={GarminIcon} alt={`Garmin`} />
          </ListItemIcon>
        </ListItem>

        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('GOOGLE_FIT')}
          selected={this.state.integration === 'GOOGLE_FIT'}
          style={{ marginBottom: 16 }}
        >
          <ListItemIcon>
            {this.state.integration === 'GOOGLE_FIT' ? <CheckedCircleIcon /> : <EmptyCircleIcon />}
          </ListItemIcon>
          <ListItemText primary={`Google Fit`} />
          <ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="google-fit" src={GoogleFitIcon} alt={`Google Fit`} />
          </ListItemIcon>
        </ListItem>

        {/*<ListItem
            button
            disableRipple
            onClick={this.setIntegration('HUAWEI')}
            selected={this.state.integration === 'HUAWEI'}
            style={{ marginBottom: 16 }}
          >
            <ListItemIcon>
              {this.state.integration === 'HUAWEI' ? <CheckedCircleIcon /> : <EmptyCircleIcon />}
            </ListItemIcon>
            <ListItemText primary={`HUAWEI Health Kit`} />
            <ListItemIcon style={{ minWidth: 'auto' }}>
              <img className="huawei" src={HuaweiHealthKitIcon} alt={`HUAWEI Health Kit`} />
            </ListItemIcon>
          </ListItem>*/}

        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('POLAR')}
          selected={this.state.integration === 'POLAR'}
          style={{ marginBottom: 16 }}
        >
          <ListItemIcon>
            {this.state.integration === 'POLAR' ? <CheckedCircleIcon /> : <EmptyCircleIcon />}
          </ListItemIcon>
          <ListItemText primary={`Polar Flow`} />
          <ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="polar" src={PolarIcon} alt={`Polar`} />
          </ListItemIcon>
        </ListItem>

        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('SUUNTO')}
          selected={this.state.integration === 'SUUNTO'}
          style={{ marginBottom: 16 }}
        >
          <ListItemIcon>
            {this.state.integration === 'SUUNTO' ? <CheckedCircleIcon /> : <EmptyCircleIcon />}
          </ListItemIcon>
          <ListItemText primary={`Suunto`} />
          <ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="suunto" src={SuuntoIcon} alt={`Suunto`} />
          </ListItemIcon>
        </ListItem>

        <ListItem
          button
          disableRipple
          onClick={this.setIntegration(null)}
          selected={this.state.integration === null}
          style={{ marginBottom: 16 }}
        >
          <ListItemIcon>{this.state.integration === null ? <CheckedCircleIcon /> : <EmptyCircleIcon />}</ListItemIcon>
          <ListItemText primary={t`No integration`} />
          <ListItemIcon style={{ minWidth: 'auto' }}>{t`Manual entry`}</ListItemIcon>
        </ListItem>
      </List>

      {/*<ButtonGroup>
        <YumButton onClick={this.onClickIntegration} to={this.doIntegration()}>{t`Next`}</YumButton>
      </ButtonGroup>*/}

      <ButtonGroup>
        {this.state.integration === 'GOOGLE_FIT' ? (
          <YumButton
            to={this.doIntegration()}
            style={{
              width: 'auto',
              whiteSpace: 'nowrap',
              //fontWeight: 400,
              //paddingLeft: 16,
              //paddingRight: 16,
              marginBottom: 16,
              margin: '0 auto',
              lineHeight: '36px',
              //fontSize: '14px',
              display: 'inline-block',
              textTransform: 'unset',

              fontFamily: 'Roboto, arial, sans-serif',
              fontSize: '16px',
              fontWeight: 500,
              letterSpacing: '.21px',

              backgroundColor: '#4285f4',
              padding: 0,
              border: '1px solid #4285f4',
              overflow: 'hidden',

              borderRadius: '2px',
              transition: 'none',
            }}
          >
            <>
              <div
                style={{
                  display: 'inline-block',
                  backgroundColor: 'white',
                  lineHeight: '18px',
                  padding: '14px',
                }}
              >
                <GoogleIcon />
              </div>
              <span style={{ display: 'inline-block', margin: '0 14px' }}>{t`Sign in with Google`}</span>
            </>
          </YumButton>
        ) : (
          <YumButton onClick={this.onClickIntegration} to={this.doIntegration()}>{t`Next`}</YumButton>
        )}
      </ButtonGroup>
    </>
  )

  getIntegrationFormNew = () => (
    <>
      <Typography variant="subtitle2" style={{ marginBottom: '20px' }}>{t`Choose integration`}</Typography>
      <List>
        <div className={'integration-title'}>
          {this.state.integration === 'APPLE_HEALTH' ? <SmallCheckIcon style={{ marginRight: '6px' }} /> : ''}
          <img
            style={{ display: 'inline-block', width: 'auto', margin: 0 }}
            className="apple-health"
            src={AppleHealthIcon}
            alt={`Apple Health`}
          />
        </div>
        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('APPLE_HEALTH')}
          selected={true /*this.state.integration === 'APPLE_HEALTH'*/}
          style={{ marginBottom: 16, backgroundColor: 'white' }}
        >
          <ListItemIcon style={{ paddingLeft: 14 }}>
            <AppleSmallIcon />
          </ListItemIcon>
          <ListItemText style={{ textAlign: 'center', marginRight: 32 }} primary={`Sign in with Apple`} />
          {/*<ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="apple-health" src={AppleHealthIcon} alt={`Apple Health`} />
          </ListItemIcon>*/}
        </ListItem>

        <div className={'integration-title'}>
          {this.state.integration === 'FITBIT' ? <SmallCheckIcon style={{ marginRight: '6px' }} /> : ''}
          <img
            style={{ display: 'inline-block', width: 'auto', margin: 0 }}
            className="fitbit"
            src={FitbitIcon}
            alt={`Fitbit`}
          />
        </div>
        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('FITBIT')}
          selected={true /*this.state.integration === 'FITBIT'*/}
          style={{ backgroundColor: 'white' }}
        >
          <ListItemIcon style={{ paddingLeft: 14 }}>
            <FitbitSmallIcon />
          </ListItemIcon>
          <ListItemText style={{ textAlign: 'center', marginRight: 32 }} primary={`Sign in with Fitbit`} />
          {/*<ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="fitbit" src={FitbitIcon} alt={`Fitbit`} />
          </ListItemIcon>*/}
        </ListItem>

        <div className={'integration-title'}>
          {this.state.integration === 'GARMIN' ? <SmallCheckIcon style={{ marginRight: '6px' }} /> : ''}
          <img
            style={{ display: 'inline-block', width: 'auto', margin: 0 }}
            className="garmin"
            src={GarminIcon}
            alt={`Garmin`}
          />
        </div>
        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('GARMIN')}
          selected={true /*this.state.integration === 'GARMIN'*/}
          style={{ marginBottom: 16, backgroundColor: 'white' }}
        >
          <ListItemIcon style={{ paddingLeft: 14 }}>
            <GarminSmallIcon />
          </ListItemIcon>
          <ListItemText style={{ textAlign: 'center', marginRight: 32 }} primary={`Sign in with Garmin`} />
          {/*<ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="garmin" src={GarminIcon} alt={`Garmin`} />
          </ListItemIcon>*/}
        </ListItem>

        <div className={'integration-title'}>
          {this.state.integration === 'GOOGLE_FIT' ? <SmallCheckIcon style={{ marginRight: '6px' }} /> : ''}
          <img
            style={{ display: 'inline-block', width: 'auto', margin: 0 }}
            className="google-fit"
            src={GoogleFitIcon}
            alt={`Google Fit`}
          />
        </div>
        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('GOOGLE_FIT')}
          selected={true /*this.state.integration === 'GOOGLE_FIT'*/}
          style={{ marginBottom: 16, backgroundColor: 'white' }}
        >
          <ListItemIcon style={{ paddingLeft: 14 }}>
            <GoogleSmallIcon />
          </ListItemIcon>
          <ListItemText style={{ textAlign: 'center', marginRight: 32 }} primary={`Sign in with Google`} />
          {/*<ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="google-fit" src={GoogleFitIcon} alt={`Google Fit`} />
          </ListItemIcon>*/}
        </ListItem>

        {/*<ListItem
            button
            disableRipple
            onClick={this.setIntegration('HUAWEI')}
            selected={this.state.integration === 'HUAWEI'}
            style={{ marginBottom: 16 }}
          >
            <ListItemIcon>
              {this.state.integration === 'HUAWEI' ? <CheckedCircleIcon /> : <EmptyCircleIcon />}
            </ListItemIcon>
            <ListItemText primary={`HUAWEI Health Kit`} />
            <ListItemIcon style={{ minWidth: 'auto' }}>
              <img className="huawei" src={HuaweiHealthKitIcon} alt={`HUAWEI Health Kit`} />
            </ListItemIcon>
          </ListItem>*/}

        <div className={'integration-title'}>
          {this.state.integration === 'POLAR' ? <SmallCheckIcon style={{ marginRight: '6px' }} /> : ''}
          <img
            style={{ display: 'inline-block', width: 'auto', margin: 0 }}
            className="polar"
            src={PolarIcon}
            alt={`Polar`}
          />
        </div>
        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('POLAR')}
          selected={true /*this.state.integration === 'POLAR'*/}
          style={{ marginBottom: 16, backgroundColor: 'white' }}
        >
          <ListItemIcon style={{ paddingLeft: 14 }}>
            <PolarSmallIcon />
          </ListItemIcon>
          <ListItemText style={{ textAlign: 'center', marginRight: 32 }} primary={`Sign in with Polar`} />
          {/*<ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="polar" src={PolarIcon} alt={`Polar`} />
          </ListItemIcon>*/}
        </ListItem>

        <div className={'integration-title'}>
          {this.state.integration === 'SUUNTO' ? <SmallCheckIcon style={{ marginRight: '6px' }} /> : ''}
          <img
            style={{ display: 'inline-block', width: 'auto', margin: 0 }}
            className="suunto"
            src={SuuntoIcon}
            alt={`Suunto`}
          />
        </div>
        <ListItem
          button
          disableRipple
          onClick={this.setIntegration('SUUNTO')}
          selected={true /*this.state.integration === 'SUUNTO'*/}
          style={{ marginBottom: 16, backgroundColor: 'white' }}
        >
          <ListItemIcon style={{ paddingLeft: 14 }}>
            {/*<SuuntoSmallIcon />*/}
            <img src={SuuntoSmallIcon} style={{ width: '18px', height: '18px' }} alt={`Suunto App logo`} />
          </ListItemIcon>
          <ListItemText style={{ textAlign: 'center', marginRight: 32 }} primary={`Sign in with Suunto`} />
          {/*<ListItemIcon style={{ minWidth: 'auto' }}>
            <img className="suunto" src={SuuntoIcon} alt={`Suunto`} />
          </ListItemIcon>*/}
        </ListItem>

        <div className={'integration-title'}>
          {this.state.integration === null ? <SmallCheckIcon style={{ marginRight: '6px' }} /> : ''}
          {t`Manual entry`}
        </div>
        <ListItem
          button
          disableRipple
          onClick={this.setIntegration(null)}
          selected={true /*this.state.integration === null*/}
          style={{ marginBottom: 16, backgroundColor: 'white' }}
        >
          {/*<ListItemIcon>{this.state.integration === null ? <CheckedCircleIcon /> : <EmptyCircleIcon />}</ListItemIcon>*/}
          <ListItemText style={{ textAlign: 'center' }} primary={t`No integration`} />
          {/*<ListItemIcon style={{ minWidth: 'auto' }}>{t`Manual entry`}</ListItemIcon>*/}
        </ListItem>
      </List>

      {/*<ButtonGroup>
        <YumButton onClick={this.onClickIntegration} to={this.doIntegration()}>{t`Next`}</YumButton>
      </ButtonGroup>*/}

      {/*<ButtonGroup>
        {this.state.integration === 'GOOGLE_FIT' ? (
          <YumButton
            to={this.doIntegration()}
            style={{
              width: 'auto',
              whiteSpace: 'nowrap',
              //fontWeight: 400,
              //paddingLeft: 16,
              //paddingRight: 16,
              marginBottom: 16,
              margin: '0 auto',
              lineHeight: '36px',
              //fontSize: '14px',
              display: 'inline-block',
              textTransform: 'unset',

              fontFamily: 'Roboto, arial, sans-serif',
              fontSize: '16px',
              fontWeight: 500,
              letterSpacing: '.21px',

              backgroundColor: '#4285f4',
              padding: 0,
              border: '1px solid #4285f4',
              overflow: 'hidden',
            }}
          >
            <>
              <div
                style={{
                  display: 'inline-block',
                  backgroundColor: 'white',
                  lineHeight: '18px',
                  padding: '14px',
                }}
              >
                <GoogleIcon />
              </div>
              <span style={{ display: 'inline-block', margin: '0 14px' }}>{t`Sign in with Google`}</span>
            </>
          </YumButton>
        ) : (
          <YumButton onClick={this.onClickIntegration} to={this.doIntegration()}>{t`Next`}</YumButton>
        )}
      </ButtonGroup>*/}
    </>
  )

  appleHealthNonIosProcess = () => {
    const { appleHealthNonIosProcessSuccess, appleHealthPasswordError } = this.state
    const { passwordSet, googleId, appleId } = this.props.userDto

    const msg = t`Successfully set password`
    const notificationProps = {
      notification: { content: msg, type: 'success' as TNotificationType },
    }

    return appleHealthNonIosProcessSuccess || passwordSet || googleId || appleId ? (
      <>
        {appleHealthNonIosProcessSuccess ? <Notifications {...notificationProps} /> : ''}

        <Typography variant="h1">{t`Download the YuMuuv application`}</Typography>

        <Typography
          style={{ marginBottom: 25 }}
        >{t`Download YuMuuv from the App Store. Log in with your email and password.`}</Typography>

        <a href="https://itunes.apple.com/us/app/yumuuv/id1459357799?mt=8">
          <img src={DownloadOnAppstore} className="apple-link" alt={`App store link`} />
        </a>
      </>
    ) : (
      <>
        <Typography variant="subtitle2" style={{ marginBottom: 16 }}>{t`Edit profile`}</Typography>

        <TextField
          label={t`Add password:`}
          type="password"
          name="password"
          required={true}
          error={appleHealthPasswordError}
          style={{
            marginBottom: 16,
          }}
          onChange={this.handleInputChange}
        />
        <ButtonGroup>
          <YumButton onClick={this.doAppleHealthIntegration}>{t`Next`}</YumButton>
        </ButtonGroup>
      </>
    )
  }

  doAppleHealthIntegration = () => {
    const { registerAppleHealth } = this.props
    const { password } = this.state
    if (password.trim().length < 6) {
      this.setState({ appleHealthPasswordError: true })
      return
    }
    registerAppleHealth({ password })

    this.setState({ appleHealthNonIosProcessSuccess: false, appleHealthPasswordError: false })
  }

  /*async getMetadataFromAppleHealth() {
    console.log('getMetadataFromAppleHealth')
    const { health } = navigator as any
    if (health) {
      //const read = AppleHealthDataTypes.map((i) => i.dataType)
      const scope = [{ read: ['date_of_birth', 'height', 'weight', 'gender'] }]
      await health.requestAuthorization(scope)

      await health.query(
        {
          dataType: 'gender',
          endDate: new Date(),
          startDate: new Date(),
        },
        (success: any) => {
          const { value } = success[0]
          const gender = value.toUpperCase() === Gender.FEMALE ? Gender.FEMALE : Gender.MALE
          this.setState({ gender: gender })
        },
        (error: any) => console.log('getMetadataFromAppleHealth:gender error', error),
      )

      await health.query(
        {
          dataType: 'date_of_birth',
          endDate: new Date(),
          startDate: new Date(),
        },
        (success: any) => {
          const { value } = success[0]
          const year = String(value.year)
          const month = String(value.month).padStart(2, '0')
          const day = String(value.day).padStart(2, '0')
          const dateOfBirth = `${day}.${month}.${year}`
          this.setState({ dateOfBirth })
        },
        (error: any) => console.log('getMetadataFromAppleHealth:date_of_birth error', error),
      )

      await health.query(
        {
          dataType: 'height',
          endDate: new Date(),
          startDate: new Date(new Date().getTime() - 5 * 365 * 24 * 60 * 60 * 1000), // last 5 years
          limit: 1,
        },
        (success: any) => {
          if (success[0]) {
            const height = Math.round(success[0].value * 100)
            this.setState({ height })
          }
        },
        (error: any) => console.log('getMetadataFromAppleHealth:height error', error),
      )

      await health.query(
        {
          dataType: 'weight',
          endDate: new Date(),
          startDate: new Date(new Date().getTime() - 5 * 365 * 24 * 60 * 60 * 1000), // last 5 years
          limit: 1,
        },
        (success: any) => {
          if (success[0]) {
            const weight = Math.round(success[0].value)
            this.setState({ weight })
          }
        },
        (error: any) => console.log('getMetadataFromAppleHealth:weight error', error),
      )
    }
  }*/

  getOnboardingStep = () => {
    const { userDto, reLocate } = this.props
    const { onboardingStatus } = userDto
    const path = redirectUrl()
    console.log('getOnboardingStep')

    switch (onboardingStatus) {
      case OnboardingStatus.PROFILE_DATA: {
        return this.getProfileForm()
      }
      case OnboardingStatus.ACTIVITY_DATA: {
        return this.getActivityForm()
      }
      case OnboardingStatus.INTEGRATION: {
        // TODO:
        return this.getIntegrationForm() //currentLang === Lang.EN ? this.getIntegrationForm() : this.getIntegrationFormNew()
      }
      default:
        return (
          <div className="loader-wrapper text-center">
            {/*<div style={{ maxWidth: '75%', marginLeft: 'auto', marginRight: 'auto', marginBottom: 10 }}>
              {t`If you've been on this page for more than 5 seconds, then click here`}:
            </div>
            <Button text={t`Back`} url={path} />*/}
            <Loader />
          </div>
        )
    }
  }

  render() {
    const { appleHealthNonIosProcess } = this.state
    return (
      <Card className="onboarding">
        <div className="onboarding__form">
          <NotificationsWrapper />
          {appleHealthNonIosProcess ? this.appleHealthNonIosProcess() : this.getOnboardingStep()}
        </div>
        <div className="onboarding__sidebar" />
      </Card>
    )
  }
}
